import { memo } from 'react'
import { Peoples, Plus } from '@icon-park/react'

import { useRouting } from '@/hooks'
import { Button, Flex } from '@/components'
import { ManualCard, Modal } from '@/components/derived'

import { useCompanyContext } from '../CompanyDetails.context'
import { getDescription } from '../utils'
import { SpokespersonsTable } from './Spokespeople.table'
import { EditSpokespersonModal } from './edit-modal/EditModal.component'
import { AddSpokespersonFormModal } from './components/add-spokesperson-form-modal/AddSpokespersonFormModal.component'

export const Spokespersons = memo(Component)

function Component(): JSX.Element | null {
  const { companyID, changeQueryParam, queryParams } = useRouting()
  const { company, reloadCompany } = useCompanyContext()

  if (!companyID || !company) return null

  return (
    <>
      <ManualCard
        icon={Peoples}
        healthCheck={true}
        title="Porta-vozes"
        tooltip="Monitore os representantes oficiais da empresa. Cadastre o nome e selecione em quais marcas ele pontua e em quais marcas contribui para o CENA."
        description={getDescription(company.counts?.spokespeople)}
        linkName="Editar"
        linkAction={() =>
          changeQueryParam({
            param: 'modal',
            value: 'porta-vozes',
            replaceAll: true,
          })
        }
      />
      <Modal
        controlKey="porta-vozes"
        backToName={company.name}
        title="Porta-vozes"
        subtitle={<span>Gerencie os porta-vozes desta empresa.</span>}
        icon={Peoples}
        beforeClose={reloadCompany}>
        <Flex $type="column" $align="stretch" $gap={24} $fit>
          <Flex $type="row" $justify="flex-end" $fit>
            <Button.Root
              $variant="primary"
              onClick={() => changeQueryParam({ param: 'addSpokesperson', value: 'true' })}>
              <Button.Icon value={Plus} />
              <Button.Text value="Adicionar Porta-voz" />
            </Button.Root>
          </Flex>
          <SpokespersonsTable />
        </Flex>
      </Modal>

      {queryParams.addSpokesperson && (
        <AddSpokespersonFormModal onSuccess={() => changeQueryParam({ param: 'addSpokesperson', value: undefined })} />
      )}
      <EditSpokespersonModal />
    </>
  )
}
